import axios from '@/jslib/axios'

export const exportMarketingList = data => {
  return axios({
    method: 'post',
    url: '/admin/marketing/report/export',
    data
  })
}
export const getMarketingList = params => {
  return axios({
    method: 'get',
    url: '/admin/marketing/report/export/list',
    params
  })
}
export const delMarketingExport = data => {
  return axios({
    method: 'delete',
    url: '/admin/marketing/report/export/del',
    data
  })
}
export const marketingProfessionalList = data => {
  return axios({
    method: 'post',
    url: '/admin/professional/user/list',
    data
  })
}
